<template>
  <div class="scoreCalcRule automate allot-rule">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        指标得分规则
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入指标名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('ScoreCalcRule,operation')"
          type="primary"
          class="m-l-10"
          @click="doNew"
        >
          新增指标
        </el-button>
        <el-button type="primary" class="m-l-10" @click="openRanks()">
          模拟多指标排行
        </el-button>
        <el-button
          v-if="osg.has('ScoreCalcRule,operation')"
          type="primary"
          class="m-l-10"
          @click="initClick()"
        >
          初始化得分
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="getRank(scope.row)">
                    查看排行榜
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="recalculate(scope.row._id)">
                    重新计算管家该指标得分
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 编辑得分规则 -->
    <el-dialog
      title="指标得分规则"
      :visible.sync="openDetail"
      width="1200px"
      :close-on-click-modal="false"
      class="c-dialog"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="110px"
        @changeForm="osg.changeForm"
        :error="true"
      >
        <template slot="regions">
          <el-select
            v-model="formData.regions"
            placeholder="请选择"
            multiple
            @change="regionsChange()"
            clearable
          >
            <el-option
              v-for="item in options.regions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="indexCalcParams">
          <el-form ref="indexCalcForm" :model="formData">
            <el-card shadow="hover" body-style="padding:0" class="c-card">
              <div class="param-card">
                <el-table :data="formData.indexCalcParams">
                  <el-table-column label="参数名称">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="`indexCalcParams[${scope.$index}].name`"
                        :rules="[{ required: true, message: '不能为空', trigger: 'change, blur' }]"
                      >
                        <el-select
                          @change="scope.row.val = ''"
                          :value="scope.row.name"
                          placeholder="请选择"
                          filterable
                        >
                          <el-option
                            v-for="item in options.indexCalcParams"
                            :key="item.value"
                            :label="item.nameDisp"
                            :value="item.nameDisp"
                            :disabled="
                              formData.indexCalcParams.some(
                                K =>
                                  K.key == item.name ||
                                  (item.name.endsWith('Inverse')
                                    ? item.name.substring(0, item.name.length - 7) == K.key
                                    : item.name + 'Inverse' == K.key)
                              )
                            "
                            @click.native="setRowData(scope.row, item)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="字段" width="1">
                    <template slot-scope="scope">
                      <el-form-item>
                        <el-input disabled v-model="scope.row.key"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="值">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="`indexCalcParams[${scope.$index}].val`"
                        :rules="{
                          required: true,
                          message: '不能为空'
                        }"
                      >
                        <template v-if="scope.row.dataType === 'date'">
                          <el-date-picker
                            style="width: 100%;"
                            v-model="scope.row.val"
                            type="datetime"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                          ></el-date-picker>
                        </template>
                        <template v-else-if="scope.row.dataType === 'cascade'">
                          <el-cascader
                            style="width: 100%;"
                            v-model="scope.row.val"
                            :options="options[scope.row.valueOption]"
                            :props="{
                              multiple: true,
                              checkStrictly: true,
                              label: 'name',
                              emitPath: false
                            }"
                            filterable
                            clearable
                          ></el-cascader>
                        </template>
                        <!-- 取值合同逻辑不可以多选 -->
                        <template v-else-if="scope.row.dataType === 'select'">
                          <el-select
                            style="width: 100%;"
                            :multiple="
                              options.indexCalcParams.find(item => item.nameDisp == scope.row.name)
                                .multiple
                            "
                            v-model="scope.row.val"
                            placeholder="请选择"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in options[scope.row.valueOption]"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </template>
                        <template v-else-if="scope.row.dataType === 'number'">
                          <el-input
                            type="number"
                            placeholder="请输入内容"
                            v-model="scope.row.val"
                            clearable
                          ></el-input>
                        </template>
                        <template v-else>
                          <el-input
                            placeholder="请输入内容"
                            v-model="scope.row.val"
                            clearable
                          ></el-input>
                        </template>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="备注">
                    <template slot-scope="scope">
                      <el-form-item>
                        <el-input v-model="scope.row.memo"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                      <div class="c-flex c-flex-between">
                        <!-- <span class="c_blue c_pointer" @click="copyIndexCalcParam(scope.$index)">
                        复制
                      </span> -->
                        <span
                          v-if="osg.has('ScoreCalcRule,operation')"
                          class="c_red c_pointer"
                          @click="removeIndexCalcParam(scope.$index)"
                        >
                          删除
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <el-button
                v-if="osg.has('ScoreCalcRule,operation')"
                plain
                type="primary"
                icon="el-icon-plus"
                class="button_dashed"
                @click="newIndexCalcParam"
              >
                新增参数
              </el-button>
              <span class="c_p_10" style="color:rgb(96, 98, 102)">
                <i class="el-icon-info c_blue"></i>
                如果用户配置时不选择“合同取值逻辑”指标计算参数，系统将按照周期内还原匹配进行计算取值。
              </span>
            </el-card>
          </el-form>
        </template>
        <template slot="scoreCalcParams">
          <el-card shadow="hover" body-style="padding:0" class="c-card">
            <div class="param-card">
              <el-table :data="formData.scoreCalcParams">
                <!-- <el-table-column label="参数类型" width="120px">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.type"
                      placeholder="请选择"
                      @change="
                        scope.row.min = '';
                        scope.row.max = '';
                        scope.row.val = '';
                      "
                    >
                      <el-option
                        v-for="item in options.calcParamsType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column> -->
                <el-table-column label="参数名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="最小值">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.min" type="number" :min="0"></el-input>
                    <!-- <el-input-number
                      v-if="scope.row.type == 'percentage'"
                      v-model="scope.row.val1"
                      :controls="false"
                      class="c-percentage"
                    ></el-input-number>
                    <el-date-picker
                      v-else-if="scope.row.type == 'datetimerange'"
                      v-model="scope.row.val1"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="00:00:00"
                      prefix-icon=""
                      :clearable="false"
                      class="c-date-piker"
                    ></el-date-picker> -->
                  </template>
                </el-table-column>
                <el-table-column label="最大值">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.max"
                      type="number"
                      :min="scope.row.min || 0"
                    ></el-input>
                    <!-- <el-input-number
                      v-if="scope.row.type == 'percentage'"
                      v-model="scope.row.val2"
                      :controls="false"
                      class="c-percentage"
                    ></el-input-number>
                    <el-date-picker
                      v-else-if="scope.row.type == 'datetimerange'"
                      v-model="scope.row.val2"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" 
                      default-time="00:00:00"
                      prefix-icon=""
                      :clearable="false"
                      class="c-date-piker"
                    ></el-date-picker> -->
                  </template>
                </el-table-column>
                <el-table-column label="得分">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.val"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="备注">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.memo"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80px">
                  <template slot-scope="scope">
                    <div class="c-flex c-flex-around">
                      <span class="c_blue c_pointer" @click="copyScoreCalcParam(scope.$index)">
                        复制
                      </span>
                      <span
                        v-if="osg.has('ScoreCalcRule,operation')"
                        class="c_red c_pointer"
                        @click="removeScoreCalcParam(scope.$index)"
                      >
                        删除
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-button
              v-if="osg.has('ScoreCalcRule,operation')"
              plain
              type="primary"
              icon="el-icon-plus"
              class="button_dashed"
              @click="newScoreCalcParam"
            >
              新增参数
            </el-button>
            <span class="c_p_10" style="color:rgb(96, 98, 102)">
              <i class="el-icon-info c_blue"></i>
              按等比例分配得分：仅需设置上下限值，系统自动计算区间分数，第一条为上限，第二条为下限。
            </span>
          </el-card>
        </template>
      </c-form>
      <div slot="footer">
        <div></div>
        <div>
          <el-button type="primary" @click="doSave">确 定</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 单指标排行 -->
    <el-dialog
      :title="rank.formData.name"
      :visible.sync="rank.show"
      :close-on-click-modal="false"
      width="500px"
      class="c-dialog-rank"
    >
      <el-table ref="table" :data="rank.fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
        <el-table-column label="排名" width="150px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName" width="150px"></el-table-column>
        <el-table-column label="分数" prop="scoreVal" width="150px"></el-table-column>
      </el-table>
      <!-- <el-pagination
        class="pagination"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="rank.fpi.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="rank.fpi.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="rank.fpi.total"
      ></el-pagination> -->
    </el-dialog>
    <!-- 模拟多指标排行 -->
    <el-dialog
      title="模拟多指标排行"
      :visible.sync="ranks.show"
      :close-on-click-modal="false"
      width="1000px"
      class="c-dialog-ranks"
    >
      <el-form :model="ranks.formData" ref="ranksForm" label-width="110px" label-position="left">
        <el-form-item
          label="行政区划"
          prop="region"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="ranks.formData.region"
            @change="ranksRegionChange"
            clearable
            placeholder="请先选择行政区划"
          >
            <el-option
              v-for="(item, i) in options.regions"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务区域" prop="stcIds">
          <el-select
            v-model="ranks.formData.stcIds"
            filterable
            multiple
            clearable
            placeholder="默认取所选行政区划下全部服务区域"
            :no-data-text="
              !ranks.formData.region ? '请先选择行政区划' : '当前行政区划下没有服务区域'
            "
          >
            <el-option
              v-for="(item, i) in options.serviceTerritory"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="得分模式"
          prop="scoreType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select v-model="ranks.formData.scoreType" clearable placeholder="默认为实时得分">
            <el-option label="实时得分" value="new"></el-option>
            <el-option label="标准得分" value="prepared"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务资源类型"
          prop="resourceType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="ranks.formData.resourceType"
            clearable
            placeholder="默认为技术工程师"
            @change="ranksResourceTypeChange"
          >
            <el-option
              v-for="(item, i) in options.resourceType"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="指标"
          prop="indexs"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="ranks.formData.indexs"
            filterable
            multiple
            clearable
            style="margin-bottom:18px;"
            :no-data-text="
              !ranks.formData.region ? '请先选择行政区划' : '没有适用当前服务资源类型的指标'
            "
            @change="indexsChange"
          >
            <template v-for="(item, i) in options.rules">
              <el-option
                v-if="
                  ranks.formData.region &&
                    item.regions.indexOf(ranks.formData.region) != -1 &&
                    ranks.formData.resourceType == item.appointType
                "
                :key="i"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </template>
          </el-select>
          <el-form-item
            v-for="(value, index) in ranks.formData.indexs"
            :key="index"
            label-width="250px"
            :label="options.rules.filter(item => item._id == value)[0].name"
          >
            <el-input-number
              v-model="ranks.formData.indexObj[value]"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入指标权重"
              class="input-number-ranks"
            ></el-input-number>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getRanks">生成排行</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="ranksTable" :data="ranks.data" empty-text="暂无数据" style="height:100%">
        <el-table-column label="排名" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          prop="userName"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="总分" prop="allScore" width="80px"></el-table-column>
        <el-table-column label="调整分数" prop="adjust" width="80px"></el-table-column>
        <template v-for="(value, key, index) in ranks.data[0]">
          <el-table-column
            v-if="key.indexOf('+') != -1"
            :key="index"
            :label="key.split('+')[0] + '得分'"
            :prop="key"
            width="150px"
          ></el-table-column>
        </template>
      </el-table>
    </el-dialog>
    <!-- 初始化得分 -->
    <el-dialog
      title="初始化得分"
      :visible.sync="init.show"
      :close-on-click-modal="false"
      width="500px"
      class="c-dialog-init"
    >
      <el-form
        :model="init.formData"
        ref="ranksForm"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="行政区划" prop="region">
          <el-select
            v-model="init.formData.region"
            filterable
            clearable
            placeholder="非必选，不选则匹配全部行政区划"
          >
            <el-option
              v-for="(item, i) in options.regions"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指标" prop="srcId">
          <el-select
            v-model="init.formData.srcId"
            filterable
            clearable
            placeholder="非必选，不选则匹配全部指标"
          >
            <el-option
              v-for="(item, i) in options.rules"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div></div>
        <el-button type="primary" @click="initScore">初始化得分</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'scoreCalcRule',
  data() {
    window.$this = this;
    return {
      name: 'scoreCalcRule',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        indexCalcParams: [
          {
            // type: 'percentage',
            name: '',
            key: '',
            val: '',
            memo: '',
            dataType: '', //数据类型
            valueOption: '' //关联的字典表
          }
        ],
        scoreCalcParams: [
          {
            // type: 'datetimerange',
            name: '',
            min: null,
            max: null,
            val: '',
            memo: ''
          }
        ],
        exts: {}
      },
      // 单指标排行
      rank: {
        show: false,
        formData: {},
        fpi: {
          page: 1,
          rows: 20,
          data: []
        }
      },
      // 标模拟多指标排行
      ranks: {
        show: false,
        formData: {
          stcIds: [],
          indexs: [],
          indexObj: {}
        },
        data: []
      },
      init: { show: false, formData: {} },
      rules: this.$util.rules,
      options: {
        // codecfg_calcParamsType: { codeId: 'calcParamsType' }
        rules: [],
        referGroupId: [], //新手资源池ID
        referRuleId: [], //参考指标
        serviceTerritory: [],
        serviceTerritoryCustom: [],
        indexCalcParams: [],
        codecfg_resourceType: { codeId: 'resourceType' }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.doInit();
    this.getAllData();
    this.osg.getFields('scoreCalcRule', () => {
      this.osg.getFpi();
      this.getData();
      //查询资源池 接口
      this.getResourcePool();
    });
    this.osg.getFields(
      'indexCalcParams',
      () => {
        console.log('indexCalcParams', this.options.indexCalcParams);
        this.getServiceTerritoryCustom();
      },
      '',
      'options.indexCalcParams'
    );
  },
  methods: {
    pageSizeChange(pageSize) {
      // if (this.rank.show) {
      //   this.rank.fpi.rows = pageSize;
      //   this.getRank();
      // } else {
      this.fpi.rows = pageSize;
      this.getData();
      // }
    },
    pageChange(currentPage) {
      // if (this.rank.show) {
      //   this.rank.fpi.page = currentPage;
      //   this.getRank();
      // } else {
      this.fpi.page = currentPage;
      this.getData();
      // }
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        indexCalcParams: [
          {
            // type: 'percentage',
            name: '',
            key: '',
            val: '',
            memo: '',
            dataType: '', //数据类型
            valueOption: '' //关联的字典表
          }
        ],
        scoreCalcParams: [
          {
            // type: 'datetimerange',
            name: '',
            min: null,
            max: null,
            val: '',
            memo: ''
          }
        ],
        exts: {}
      };
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/scoreCalcRule/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
          //反显 处理数据  合同取值逻辑 contractLogical 字典表 contractLogical 不需要处理
          item.indexCalcParams.forEach(i => {
            if (i.key != 'contractLogical' && (i.dataType == 'cascade' || i.dataType == 'select')) {
              i.val = i.val.includes(',') ? i.val.split(',') : i.val;
            }
          });
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    getAllData() {
      this.osg.ajax(
        'biz/scoreCalcRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.rules = res.data;
          console.log(res.data);
        }
      );
    },
    getRegionsData() {
      this.osg.ajax(
        'biz/scoreCalcRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:regions|array#and': Array.isArray(this.formData.regions)
            ? this.formData.regions.join(',')
            : ''
        },
        res => {
          this.options.referRuleId = res.data.map(item => ({
            label: item.name, // 根据你的数据结构设置label
            value: item._id // 根据你的数据结构设置value
          }));
        }
      );
    },

    //查询资源池 接口
    getResourcePool() {
      this.osg.ajax(
        'biz/serviceResourceGroup/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:region|array#and': Array.isArray(this.formData.regions)
            ? this.formData.regions.join(',')
            : '',
          'is:defaultFlag|integer#and': 1
        },
        res => {
          this.options.referGroupId = res.data.map(item => ({
            label: item.name, // 根据你的数据结构设置label
            value: item._id // 根据你的数据结构设置value
          }));
        }
      );
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs.form &&
          this.$refs.form.$refs.formData &&
          this.$refs.form.$refs.formData.clearValidate();
      });
    },
    doEdit(row) {
      //如果存在老数据 检查 老数据有没有dataType属性
      const { indexCalcParams } = row;
      indexCalcParams.forEach(item => {
        item.dataType = item.dataType || item.key;
      });
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
      this.getResourcePool();
      this.getRegionsData();
      //清除上一次的效验结果
      if (this.$refs.indexCalcForm) {
        this.$refs.indexCalcForm.clearValidate();
      }
    },
    doSave() {
      // 检查并处理一下数据结构
      console.log('处理后的数据结构', this.formData.indexCalcParams);
      this.$refs.indexCalcForm.validate(valid => {
        if (this.osg.validate() && valid) {
          //处理数据
          this.formData.indexCalcParams.forEach(item => {
            if (Array.isArray(item.val)) {
              item.val = item.val.join(','); // 将数组转换为逗号分隔的字符串
            }
          });

          this.osg.ajax(
            'biz/scoreCalcRule/upsert.do',
            { data: JSON.stringify(this.formData) },
            () => {
              this.osg.toast('保存成功');
              this.doInit();
              this.getData();
              this.getAllData();
            }
          );
        }
      });
    },
    //使用 this.$set 来确保 Vue 的响应式数据更新
    setRowData(scope, item) {
      if (
        this.formData.indexCalcParams.some(
          K =>
            K.key == item.name ||
            (item.name.endsWith('Inverse')
              ? item.name.substring(0, item.name.length - 7) == K.key
              : item.name + 'Inverse' == K.key)
        )
      )
        return;
      scope.name = item.nameDisp;
      this.$set(scope, 'dataType', item.type);
      this.$set(scope, 'key', item.name);
      this.$set(scope, 'valueOption', item.valueOption);
    },

    doEnable(id) {
      this.osg.ajax('biz/scoreCalcRule/enable.do', { id }, () => {
        this.osg.toast('启用成功');
        this.getData();
        this.getAllData();
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/scoreCalcRule/disable.do', { id }, () => {
        this.osg.toast('禁用成功');
        this.getData();
        this.getAllData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('biz/scoreCalcRule/delete.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
          this.getAllData();
        });
      });
    },
    //新增条件
    newIndexCalcParam() {
      this.formData.indexCalcParams.push({
        // type: 'percentage',
        name: '',
        key: '',
        val: '',
        memo: '',
        dataType: '', //数据类型
        valueOption: '' //关联的字典表
      });
    },
    // 复制条件
    copyIndexCalcParam(index) {
      this.formData.indexCalcParams.push(this.$util.deepCopy(this.formData.indexCalcParams[index]));
    },
    //删除条件
    removeIndexCalcParam(index) {
      this.formData.indexCalcParams.splice(index, 1);
    },
    //新增条件
    newScoreCalcParam() {
      this.formData.scoreCalcParams.push({
        // type: 'datetimerange',
        name: '',
        min: null,
        max: null,
        val: '',
        memo: ''
      });
    },
    // 复制条件
    copyScoreCalcParam(index) {
      this.formData.scoreCalcParams.push(this.$util.deepCopy(this.formData.scoreCalcParams[index]));
    },
    //删除条件
    removeScoreCalcParam(index) {
      this.formData.scoreCalcParams.splice(index, 1);
    },
    // 打开排行模拟器
    openRanks() {
      this.ranks = {
        show: true,
        formData: {
          scoreType: 'new', // 默认实时得分
          resourceType: 'technician', // 默认技师
          stcIds: [],
          indexs: [],
          indexObj: {}
        },
        data: []
      };
      this.options.serviceTerritory = [];
      this.$nextTick(() => {
        this.$refs.ranksForm && this.$refs.ranksForm.clearValidate();
      });
    },
    // 指标变更:
    indexsChange() {
      let indexObj = {};
      this.ranks.formData.indexs.map(id => {
        indexObj[id] =
          this.ranks.formData.indexObj[id] || this.ranks.formData.indexObj[id] === 0
            ? this.ranks.formData.indexObj[id]
            : undefined;
      });
      this.ranks.formData.indexObj = indexObj;
      console.log('indexObj', indexObj);
    },
    // 查看多指标综合排行
    getRanks() {
      if (!this.osg.validate('ranksForm')) {
        return;
      }
      for (let key in this.ranks.formData.indexObj) {
        if (!this.ranks.formData.indexObj[key] && this.ranks.formData.indexObj[key] !== 0) {
          this.osg.toast('指标权重不能为空', 'warning');
          return;
        }
      }
      this.osg.ajax(
        'biz/scoreUser/simulateRankList.do',
        {
          data: JSON.stringify({
            region: this.ranks.formData.region,
            stcIds: this.ranks.formData.stcIds,
            scoreType: this.ranks.formData.scoreType,
            resourceType: this.ranks.formData.resourceType,
            data: this.ranks.formData.indexObj
          })
        },
        res => {
          this.ranks.data = res.data;
        }
      );
    },
    // 查看某指标排行
    getRank(item) {
      if (item) this.rank.formData = item;
      this.osg.ajax(
        '/biz/scoreCalcRule/rankList.do',
        {
          id: this.rank.formData._id
          // page: this.rank.fpi.page || 1, rows: this.rank.fpi.rows
        },
        res => {
          this.rank.fpi = res;
          this.rank.show = true;
        }
      );
    },
    // 重新计算管家该指标得分
    recalculate(id) {
      this.osg.confirm('是否确认重新计算管家该指标得分？', () => {
        this.osg.ajax('biz/scoreCalcRule/recalculate.do', { id }, () => {
          this.osg.toast('重新计算完成');
        });
      });
    },
    // 初始化弹窗
    initClick() {
      this.init = {
        show: true,
        formData: {}
      };
    },
    // 初始化得分
    initScore() {
      this.osg.ajax(
        'biz/scoreUser/init.do',
        {
          srcId: this.init.formData.srcId,
          region: this.init.formData.region
        },
        () => {
          this.osg.toast('初始化得分完成');
          this.init = {
            show: false,
            formData: {}
          };
        }
      );
    },
    // 模拟多指标排行 行政区划变更
    ranksRegionChange() {
      // 清空原行政区划下已选择服务区域
      this.ranks.formData.stcIds = [];
      // 清空已选择的指标和权重
      this.ranks.formData.indexs = [];
      this.ranks.formData.indexObj = {};
      // 清空行政区划时，清空原行政区划下所有服务区域选项
      if (!this.ranks.formData.region) {
        this.options.serviceTerritory = [];
        return;
      }
      // 未清空行政区划时，查询当前行政区划下所有服务区域
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:regions|array#and': this.ranks.formData.region,
          sortField: 'territoryNum,createTime',
          sortOrder: 'asc'
        },
        res => {
          this.options.serviceTerritory = res.data;
        }
      );
    },
    //  模拟多指标排行 服务资源类型变更
    ranksResourceTypeChange() {
      // 清空已选择的指标和权重
      this.ranks.formData.indexs = [];
      this.ranks.formData.indexObj = {};
    },
    regionsChange() {
      this.formData.indexCalcParams.forEach(item => {
        if (item.key == 'referGroupId' || item.key == 'referRuleId') {
          item.val = ''; // 清空 val
        }
      });
      // 重新查询
      this.getResourcePool();
      this.getRegionsData();
    },
    getServiceTerritoryCustom() {
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:regions|array#and': this.ranks.formData.region,
          sortField: 'territoryNum,createTime',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritoryCustom = res.data;
        }
      );
    }
  }
};
</script>
<style lang="scss">
#app {
  .scoreCalcRule {
    .c-dialog {
      .el-dialog {
        width: 1200px;
        min-width: 1200px !important;
      }
      .c-form {
        > .el-form-item {
          > .el-form-item__content {
            width: 400px;
            .c-card {
              width: 1030px !important;
            }
          }
        }
      }
    }
    .param-card {
      display: flex;
      justify-content: space-between;
      .el-card {
        width: 90% !important;
      }
      .card-remove {
        width: 10%;
        text-align: center;
        color: #f2795b;
        cursor: pointer;
        font-size: 18px;
      }
    }
    .c-percentage {
      width: 100%;
      ::after {
        content: '%';
        position: absolute;
        right: 10px;
        top: 1px;
      }
    }
    .c-input-number {
      width: 100%;
    }
    .button_dashed {
      margin: 10px;
    }
    .el-dialog__body {
      padding: 20px 30px !important;
    }
    .c-date-piker {
      width: 100% !important;
      .el-input__inner {
        padding: 0 0 0 10px;
      }
      .el-input__prefix {
        display: none;
      }
    }
    .c-form-item {
      .el-form-item__content {
        display: flex;
      }
    }
    .c-dialog-rank {
      .el-dialog {
        width: 500px;
        min-width: 500px;
      }
    }
    .c-dialog-ranks {
      > .el-dialog {
        margin: 5vh auto !important;
        width: 1000px;
        min-width: 1000px;
        height: 90vh;
        max-height: 90vh;
        .el-dialog__body {
          // display: flex;
          // flex-direction: column;
          overflow-y: auto;
          .input-number-ranks {
            .el-input__inner {
              width: 130px;
            }
          }
          .el-table {
            flex: 1;
            .el-table__body-wrapper {
              overflow-y: auto;
              height: calc(100% - 63px);
            }
          }
        }
      }
    }
    .c-dialog-init {
      > .el-dialog {
        width: 500px;
        min-width: 500px;
      }
    }
  }
}
</style>
